import { isSchemaRecord, isString } from '../shared/runtime-values.js';
import type { SchemaInput } from '../shared/schema-input.js';
import { safeReturnTo } from '../shared/checkout-navigation.js';

/** Recover a completed payment instead of creating another subscription. */
export function checkoutNavigation(status: number, payload: SchemaInput): string | null {
  if (!isSchemaRecord(payload)) return null;
  if (status === 409 && isString(payload.return_url) && payload.return_url.startsWith('/pro/success/?')) {
    return safeReturnTo(payload.return_url);
  }
  return null;
}

export function redirectCheckoutResponse(status: number, payload: SchemaInput): boolean {
  const destination = checkoutNavigation(status, payload);
  if (!destination) return false;
  window.location.assign(destination);
  return true;
}

export class CheckoutNavigationStarted extends Error {}
